// LazyImage.jsx
import React, { useEffect, useRef, useState } from 'react';

const LazyImage = ({ src, alt, style, onLoad, onMouseMove, onMouseLeave, onError, innerRef }) => {
    const imgRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                });
            },
            { rootMargin: '100px' }
        );

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <img
            ref={(el) => {
                imgRef.current = el;
                if (innerRef) innerRef.current = el;
            }}
            src={isVisible ? src : undefined}
            alt={alt}
            style={style}
            onLoad={onLoad}
            onMouseMove={onMouseMove}
            onMouseLeave={onMouseLeave}
            onError={onError}
        />
    );
};

export default LazyImage;
